import { FC, memo, useMemo } from 'react';

import { useCMSGameCovers } from '../../../hooks';
import { GameV1 } from '@/api/games';
import { ImageComponent } from '@/components/Image';
import { getGameCover } from '@/helpers/cdn';

import {
  ScSmallLockedGameCardIcon,
  ScSmallLockedGameCardInner,
} from './styled';

interface ILockedGameCardProps {
  game: GameV1;
}

export const SmallLockedGameCard: FC<ILockedGameCardProps> = memo(
  ({ game }) => {
    const { id } = game;
    const { covers } = useCMSGameCovers();

    const url = useMemo(() => {
      return covers?.[id]?.cover?.url || getGameCover(id);
    }, [covers, id]);

    return (
      <ScSmallLockedGameCardInner>
        <ImageComponent
          alt="cover"
          src={url}
          loading="lazy"
          fill
          className="cover-image"
        />
        <div className="content">
          <ScSmallLockedGameCardIcon>
            <ImageComponent
              src="/game/lock-icon.svg"
              width={16}
              height={16}
              alt="play button icon"
            />
          </ScSmallLockedGameCardIcon>
        </div>
      </ScSmallLockedGameCardInner>
    );
  }
);
